import {validateQuery} from "js/utils"

export {}
document.querySelectorAll<HTMLElement>(".s-price-list").forEach((section) => {
  const radios = section.querySelectorAll<HTMLInputElement>(".s-price-list__radio input")
  const groups = section.querySelectorAll<HTMLElement>(".g-price-lists__cell")

  radios.forEach((radio) => {
    radio.addEventListener("change", () => {
      const selectedValue = section.querySelector<HTMLInputElement>(".s-price-list__radio input:checked")?.value

      if (selectedValue === "all") {
        groups.forEach((group) => {
          group.classList.remove("d-none")
        })

        return
      }

      groups.forEach((group) => {
        group.classList.add("d-none")

        const activeGroupSelector = `.g-price-lists__cell[data-category="${selectedValue}"]`
        if (!validateQuery(activeGroupSelector)) return

        const activeGroup = section.querySelector<HTMLElement>(activeGroupSelector)
        activeGroup?.classList.remove("d-none")
      })
    })
  })
})
